import { render } from "./WhiteLogo.vue?vue&type=template&id=53fbb233&scoped=true"
import script from "./WhiteLogo.vue?vue&type=script&lang=js"
export * from "./WhiteLogo.vue?vue&type=script&lang=js"

import "./WhiteLogo.vue?vue&type=style&index=0&id=53fbb233&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53fbb233"

export default script